import React from 'react'
import PropTypes from 'prop-types'

import { Wrapper } from 'Components/UI'
import { Button, Text } from 'Components/UI/_Legacy'

import { ROOT } from 'Constants/Paths'

import { Container, Content, Row } from './styles'

function Policy({ data = {} }) {
  const { title, text } = data
  return (
    <Container>
      <Wrapper>
        <Content>
          <Row>
            <Text as="h1" medium mt={[3, 3, 0]} title>
              {title}
            </Text>

            <Button.Link href={ROOT} outline secondary>
              Back to homepage
            </Button.Link>
          </Row>

          <Text
            letterSpacing={0.5}
            light
            lineHeight={1.71}
            markdown
            mt={[5, 5, 13]}
            small
          >
            {text}
          </Text>
        </Content>
      </Wrapper>
    </Container>
  )
}

Policy.propTypes = {
  data: PropTypes.object,
}

export default Policy
